/**
 * Order Placer field formatter (non-changeable)
 */

import {useOrderPlacer} from '@hconnect/tuc-processes/fields/orderPlacer/useOrderPlacer'

import {phoneNumberToString} from '../../../orderIntake/utils/phoneNumberUtils'

import type {FieldFormatter} from './types'

export const useOrderPlacerFormatter = (): FieldFormatter => {
  const {name, phoneNumber} = useOrderPlacer()

  return (context) => {
    const {t} = context

    // Format like SiteContactFieldButton: "Name - Phone Number"
    const formattedName = name?.trim() || null
    const formattedPhone = phoneNumber ? phoneNumberToString(phoneNumber) : null

    const displayValue = (() => {
      if (formattedName && formattedPhone) {
        return `${formattedName} - ${formattedPhone}`
      }
      return formattedName || formattedPhone || null
    })()

    const values = displayValue
      ? [{text: displayValue, isDiscarded: false, isNew: false}]
      : [
          {
            text: t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified'),
            isDiscarded: false,
            isNew: false
          }
        ]

    return {
      values,
      requiresApproval: false,
      hasChanges: false
    }
  }
}
